import { Form as FinalForm, FormSpy } from 'react-final-form';
import { Alert, Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { createGoogleMerchantDataSourceDisplayName, createGoogleMerchantProfileName, currencyOptions } from "../../utilities";
import FormFieldWithDropdown from "../../../../../components/formFields/FormFieldWithDropdown";
import FormFieldTextOrNumber from "../../../../../components/formFields/FormFieldTextOrNumber";
import { useState } from 'react';

export function AddProfileModal({ isOpen, setIsOpen, onConfirm, nextIndex }: any)
{
    const [isNameManuallyEdited, setIsNameManuallyEdited] = useState(false);

    const initialValues =
    {
        contentLanguage: 'pl',
        feedLabel: 'PL',
        currencyCode: 'PLN',
        name: createGoogleMerchantProfileName
        ({
            contentLanguage: 'pl',
            feedLabel: 'PL',
            currencyCode: 'PLN'
        }),
        dataSourceDisplayName: createGoogleMerchantDataSourceDisplayName
        ({
            feedLabel: 'PL'
        })
    };

    const handleSubmit = async (values: any) =>
    {
        await onConfirm(values);
        setIsOpen(false);
    };

    return (
        <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} size="lg">
            <ModalHeader toggle={() => setIsOpen(!isOpen)}>Dodaj profil eksportu</ModalHeader>

            <FinalForm
                initialValues={initialValues}
                onSubmit={handleSubmit}
                render={({ handleSubmit, values, form }) =>
                {
                    const currency = currencyOptions.find(option => option.id === values.currencyCode);

                    return (
                        <Form onSubmit={handleSubmit}>
                            <FormSpy
                                subscription={{ values: true }}
                                onChange={({ values }) =>
                                {
                                    if (!isNameManuallyEdited)
                                    {
                                        const generatedName = createGoogleMerchantProfileName(values);

                                        if (values.name !== generatedName)
                                        {
                                            form.change('name', generatedName);
                                        }
                                    }

                                    const generatedDataSourceDisplayName = createGoogleMerchantDataSourceDisplayName(values);

                                    if (!values.dataSourceDisplayName && generatedDataSourceDisplayName)
                                    {
                                        form.change('dataSourceDisplayName', generatedDataSourceDisplayName);
                                    }
                                }}
                            />
                            <ModalBody>
                                <div className="row">
                                    <div className="col-12 col-xl-6">
                                        <div className="mb-3">
                                            <FormFieldTextOrNumber
                                                name="name"
                                                label="Nazwa profilu"
                                                onChange={(inputOnChange: any) => (event: any) =>
                                                {
                                                    setIsNameManuallyEdited(true);
                                                    inputOnChange(event);
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <FormFieldTextOrNumber name="contentLanguage" label="Content language" />
                                        </div>
                                        <div className="mb-3">
                                            <FormFieldTextOrNumber name="feedLabel" label="Feed label" />
                                        </div>
                                        <div className="mb-3">
                                            <FormFieldTextOrNumber name="dataSourceDisplayName" label="Nazwa źródła danych" />
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-6">
                                        <div className="mb-3">
                                            <FormFieldWithDropdown
                                                name="currencyCode"
                                                label="Waluta"
                                                options={currencyOptions}
                                                currentSelectionLabel={currency?.label ?? values.currencyCode ?? 'Wybierz'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <Button type="submit" color="primary">Dodaj profil</Button>
                                <Button type="button" color="secondary" onClick={() => setIsOpen(false)}>
                                    Anuluj
                                </Button>
                            </ModalFooter>
                        </Form>
                    );
                }}
            />
        </Modal>
    );
}
